<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
        method="get"
        accept-charset="utf-8"
        class="c-form"
    >
        <button v-if="isFormVisible" type="button" @click="hideForm" class="c-btn is-close" :class="{
            'is-open': isOpen
        }">
            <i aria-hidden="true" class="ico ico-close"></i>
        </button>

        <div class="c-form__item c-form__item--text">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                :value="keyword"
                name="search"
                autocomplete="off"
                :placeholder="inputPlaceholder"
                @input="onInput"
                @focus="showForm"
                @keyup.enter="redirectToSearch"
                :class="{
                    'c-form__input': true,
                    'is-empty': !keyword,
                    'is-open': isOpen
                }"
                ref="searchInput"
            />
        </div>

        <a
            :href="searchUrl"
            :class="{
                'c-btn': true,
                'c-btn--black': !isFormVisible,
                'c-btn--primary': isFormVisible,
                'is-loading': isLoading,
                'is-open': isOpen
            }"
        >
            <i class="ico ico-search"></i>
        </a>
    </form>
</template>

<script>
import RshopAutocompleteForm from "./../../../../vendor/rshop/frontend/assets/js/components/Autocomplete/Form/index.vue";

export default {
    extends: RshopAutocompleteForm,
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true
        }
    },
    methods: {
        showForm() {
            this.$emit('show-form')
        },
        hideForm() {
            this.$emit('hide-form')
        },
        onInput(event) {
            this.keyword = event.target.value

            this.search()
        },
        redirectToSearch() {
            window.location.href = this.searchUrl
        }
    },
    computed: {
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${this.keyword}` : ''}`
        }
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus()
                })
            }
        }
    }
};
</script>
